import { render } from "./TagCodeV2.vue?vue&type=template&id=339d8016&scoped=true"
import script from "./TagCodeV2.vue?vue&type=script&lang=ts"
export * from "./TagCodeV2.vue?vue&type=script&lang=ts"

import "./TagCodeV2.vue?vue&type=style&index=0&id=339d8016&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-339d8016"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon});
